export const links = [
  {
    id: 1,
    url: '/nasza_firma',
    text: 'O nas',
  },
  {
    id: 2,
    url: '/sklepy_firmowe',
    text: 'Sklepy Firmowe',
  },
  {
    id: 4,
    url: '/',
    text: 'Sklep',
  },
  {
    id: 5,
    url: '/oferta',
    text: 'Oferta',
  },
  {
    id: 6,
    url: '#contact-section',
    text: 'Kontakt',
  },
];
